//node modules
import Marquee from "react-fast-marquee";

const ApplyNowSliderSection = () => {
  return (
    <section>
      <a href="#application-form">
        <Marquee gradientWidth="0" speed="70" className="bg-custom-cyan">
          <p className="slide-text py-8 font-bold tracking-widest">
            Hemen Başvur · Hemen Başvur · Hemen Başvur · Hemen Başvur · Hemen
            Başvur · Hemen Başvur · Hemen Başvur · Hemen Başvur · Hemen Başvur ·
            Hemen Başvur · Hemen Başvur · Hemen Başvur · Hemen Başvur · Hemen
            Başvur · Hemen Başvur · Hemen Başvur · Hemen Başvur · Hemen Başvur ·
            Hemen Başvur · Hemen Başvur · Hemen Başvur · Hemen Başvur · Hemen
            Başvur · Hemen Başvur · Hemen Başvur · Hemen Başvur · Hemen Başvur ·
            Hemen Başvur · Hemen Başvur · Hemen Başvur · Hemen Başvur · Hemen
            Başvur ·&nbsp;
          </p>
        </Marquee>
      </a>
    </section>
  );
};

export default ApplyNowSliderSection;
